import React, {useCallback,useEffect,useState}from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faUsers, faClock, faPlay, faRobot, faBrain, faChartLine, faCode, faProjectDiagram, faCloud, faCheckCircle, faDatabase, faServer, faLaptopCode, faCertificate, faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub, faTwitter, faMedium } from '@fortawesome/free-brands-svg-icons';
import './HeroSection.css';

const Aimi = () => {
    const [showModal, setShowModal] = useState(false);
      const [formCourseName, setFormCourseName] = useState('AI/ML Fundamentals');
      const [formData, setFormData] = useState({
        fullName: '',
        mobileNumber: '',
        email: '',
      });
    
      const openModal = () => setShowModal(true);
      const closeModal = useCallback(() => {
        setShowModal(false);
        setFormData({ fullName: '', mobileNumber: '', email: '' });
      }, []);
    
      useEffect(() => {
        const handleEsc = (e) => {
          if (e.key === 'Escape') closeModal();
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
      }, [closeModal]);
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'mobileNumber') {
          const digitsOnly = value.replace(/\D/g, '');
          if (digitsOnly.length <= 10) {
            setFormData(prev => ({ ...prev, [name]: digitsOnly }));
          }
        } else {
          setFormData(prev => ({ ...prev, [name]: value }));
        }
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        const { fullName, mobileNumber, email } = formData;
    
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        if (!fullName || !emailRegex.test(email) || mobileNumber.length !== 10) {
          alert('Please fill in valid details.');
          return;
        }
    
        try {
          const response = await fetch('https://api.dikshasea.in/api/enrollments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...formData, course: formCourseName }),
          });
    
          const result = await response.json();
          if (response.ok) {
            alert('Enrollment successful!');
            closeModal();
          } else {
            alert(result.message || 'Submission failed');
          }
        } catch (err) {
          console.error(err);
          alert('Error submitting form');
        }
      };

  return (
    <>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <span className="badge bg-primary bg-opacity-10 text-white mb-3">New AI Course</span>
              <h1 className="hero-title">
                Master <span className="hero-highlight">AI & Machine Learning</span>
              </h1>
              <p className="hero-subtitle">
                Dive into the world of AI with our comprehensive course designed for beginners and experts alike. 
                Learn from industry leaders and gain hands-on experience with real-world projects.
              </p>
              
              <div className="course-meta">
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                  <div>
                    <div className="fw-bold">4.9/5.0</div>
                    <small className="text-muted">(2,450 reviews)</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div>
                    <div className="fw-bold">8,700+</div>
                    <small className="text-muted">Students</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <div className="fw-bold">45 hours</div>
                    <small className="text-muted">Content</small>
                  </div>
                </div>
              </div>
                 <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="ratio ratio-16x9">
                <img 
                  src="/subcourses-images/ai-ml.jpg" 
                  alt="AI & ML Course" 
                  className="img-fluid rounded-3 shadow"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
     <div className="container">
      <div className="course-details">
        <div className="course-content">
          {/* About Course */}
          <section className="about-course">
            <h2 className="section-title">About This Course</h2>
            <p>This comprehensive Data Engineering program will take you from beginner to job-ready data engineer. You'll learn to build robust data pipelines, work with big data technologies, and design efficient data warehouses.</p>
            <p>Through hands-on projects using real-world datasets, you'll gain experience with the same tools used by companies like Netflix, Airbnb, and Uber.</p>
          </section>
          
          {/* Curriculum */}
          <section className="curriculum">
            <h2 className="section-title">Curriculum</h2>
            
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faDatabase} className="me-2" /> Module 1: Foundations of Data Engineering</h3>
              <p>Learn the core concepts and architecture patterns of modern data systems</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Data modeling and warehousing</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> ETL vs ELT patterns</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Batch vs stream processing</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Data quality and governance</div>
              </div>
            </div>
            
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faServer} className="me-2" /> Module 2: Big Data Technologies</h3>
              <p>Master distributed systems for processing large-scale datasets</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Apache Hadoop ecosystem</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Apache Spark (PySpark)</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Distributed storage (HDFS, S3)</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Processing frameworks (Flink, Beam)</div>
              </div>
            </div>
            
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faCloud} className="me-2" /> Module 3: Cloud Data Platforms</h3>
              <p>Build pipelines on AWS, GCP, and Azure cloud platforms</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> AWS (Redshift, Glue, EMR)</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Google Cloud (BigQuery, Dataflow)</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure (Synapse, Data Factory)</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Cloud data warehousing</div>
              </div>
            </div>
            
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faCode} className="me-2" /> Module 4: Pipeline Development</h3>
              <p>Design and implement production-grade data pipelines</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Airflow for workflow orchestration</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Kafka for event streaming</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Data pipeline testing</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Monitoring and alerting</div>
              </div>
            </div>
            
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faProjectDiagram} className="me-2" /> Module 5: Capstone Project</h3>
              <p>Build an end-to-end data platform with real-world datasets</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Data ingestion from multiple sources</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Transformation and processing</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Storage and serving layer</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Data visualization and analytics</div>
              </div>
            </div>
          </section>
          
          
        </div>  
        
        <div className="course-sidebar">
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faClock} />
            </div>
            <div className="info-content">
              <h4>Duration</h4>
              <p>12 Weeks (20 hrs/week)</p>
            </div>
          </div>
          
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faCertificate} />
            </div>
            <div className="info-content">
              <h4>Level</h4>
              <p>Intermediate to Advanced</p>
            </div>
          </div>
          
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faLaptopCode} />
            </div>
            <div className="info-content">
              <h4>Projects</h4>
              <p>5 Real-world Projects</p>
            </div>
          </div>
          
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <div className="info-content">
              <h4>Prerequisites</h4>
              <p>Python, SQL, Basic Linux</p>
            </div>
          </div>
          
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faBriefcase} />
            </div>
            <div className="info-content">
              <h4>Career Support</h4>
              <p>Resume reviews, Mock interviews</p>
            </div>
          </div>
            <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
        </div>
      </div>
    </div>
    {/* MODAL */}
      {showModal && (
        <div
          className="modal d-block fade show"
          style={{ background: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-4 d-flex flex-column flex-md-row">
              <div className="w-100 w-md-50 mb-3 mb-md-0">
                <img
                  src="/img/enroll.jpg"
                  alt="Enrollment"
                  className="img-fluid h-100"
                  style={{ objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="w-100 w-md-50 ps-md-4">
                <h6 className="text-primary">Course:</h6>
                <h4 className="fw-bold">{formCourseName}</h4>
                <form onSubmit={handleSubmit} noValidate>
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />
                  <input
                    className="form-control mb-3"
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-outline-dark me-2" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Aimi;